// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2uRMg","header":"ReportDetails_header__SY_EF","title":"ReportDetails_title__2TR-E","left":"ReportDetails_left__27zjN"};